import { AsyncLoadingState } from "@/features/dashboard/enums/common";
import { setLoading, updateSubscriptionInfo } from "../slices/DashboardWidgetSlice";
import { RootState } from "@/models/RootState.type";
import { AppDispatch } from "@/models/AppDispatch.type";
import { setUserEntitlement } from "../slices/UserEntitlementSlice";
import { createListenerMiddleware } from "@reduxjs/toolkit";

export const addDashboardListenerMiddleware = (
  listenerMiddleware: ReturnType<typeof createListenerMiddleware>
) => {
  listenerMiddleware.startListening.withTypes<RootState, AppDispatch>()({
    actionCreator: setUserEntitlement,
    effect: async (action, listenerApi) => {
      try {
        const { userEntitlement } = listenerApi.getState() as RootState;

        const assessmentWidgetStatus = !!userEntitlement.data?.subscriptions?.assess
        const tutorWidgetStatus = !!userEntitlement.data?.subscriptions?.tutor;
        const instructWidgetStatus = !!userEntitlement.data?.subscriptions?.instruct;

        listenerApi.dispatch(updateSubscriptionInfo({
          assessmentWidgetStatus,
          tutorWidgetStatus,
          instructWidgetStatus,
        }));
      } catch (error) {
        console.error("Error fetching subscription info:", error);
        listenerApi.dispatch(setLoading(AsyncLoadingState.ERROR));
      }
    },
  });
}